import { LOUNGE_PER_SEGMENT } from '../products';
import LoungeInfoDialog from './components/LoungeInfoDialog';
export const loungePerSegmentConfig = {
  product: LOUNGE_PER_SEGMENT,
  availabilityGranularity: 'PerSegment',
  priceDisplay: 'total',
  hasInfo: true,
  InfoComponent: LoungeInfoDialog
};
export default loungePerSegmentConfig;
//# sourceMappingURL=config.js.map